import React from "react";
import { Grid, Typography } from "@material-ui/core";
import useStyles from "./styles";
import { HelpText } from "Components/Shared/HelpText/HelpText";
import { PaystubTable } from "./PaystubTable/PaystubTable";
import { PaystubReportActions } from "./PaystubReportActions/PaystubReportActions";

export const PaystubReport = () => {
  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      <HelpText>
        <b>What is the Paystub Report?</b> Evidence of the monetary amount sent to the DailyPay Account (DPA), which can be compared to paystubs to prove the values are equivalent. In addition, this report shows when the user consented to having their direct deposit updated.
      </HelpText>
      <PaystubReportActions />
      <Grid item xs={12}>
        <Typography variant="h3" className={classes.tableTitle}>
          Paystub Report
        </Typography>
        <PaystubTable />
      </Grid>
    </Grid>
  );
};
